import { Table } from 'dexie';
import db, { DataRepository, Database, Key } from '@/db';
import OfflineQueue, { QueueType } from '../models/OfflineQueueModel';
import { HeadTypeName } from '@/constants';

export type TABLE_TYPE = Table<OfflineQueue>;

export const TABLE = 'offlineQueue';
const SCHEMA = '++id, entityId, entityType, type, action, timestamp';

export class OfflineQueueRepo implements DataRepository<OfflineQueue> {
  constructor(private db: Database) {
    db.registerModelSchema(TABLE, SCHEMA);
  }

  get(key: Key): Promise<OfflineQueue | undefined> {
    return this.db[TABLE].get(key);
  }

  delete(key: Key): Promise<void> {
    return this.db[TABLE].delete(key);
  }

  update(payload: OfflineQueue): Promise<OfflineQueue> {
    return this.db[TABLE].put(payload);
  }

  bulkAdd(payload: OfflineQueue[]): Promise<OfflineQueue[]> {
    return this.db[TABLE].bulkPut(payload);
  }

  list(): Promise<OfflineQueue[]> {
    return this.db[TABLE].orderBy('timestamp').toArray();
  }

  async add(entry: OfflineQueue): Promise<OfflineQueue> {
    return this.update(entry);
  }

  clear(): Promise<void> {
    return this.db[TABLE].clear();
  }

  async findByEntity(entityId: string, type: QueueType, entityType: HeadTypeName): Promise<OfflineQueue | undefined> {
    return this.db.offlineQueue.where({ entityId, type, entityType }).first();
  }

  async deleteByEntity(entityId: string, type: QueueType, entityType: HeadTypeName): Promise<void> {
    await this.db.offlineQueue.where({ entityId, type, entityType }).delete();
  }
}

export const OfflineQueueDB = new OfflineQueueRepo(db);
